import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

function HomePage() {
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <h1 className="text-center">Bem-vindo ao Hub de Integração</h1>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={6} className="mb-4">
          <Card>
            <Card.Body>
              <h2>Integração com Marketplaces</h2>
              <p>Integre facilmente seus produtos com os maiores marketplaces.</p>
              <Button variant="primary">Ver Marketplaces</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card>
            <Card.Body>
              <h2>Estatísticas de Integração</h2>
              <p>Visualize estatísticas detalhadas sobre suas integrações.</p>
              <Button variant="primary">Ver Estatísticas</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <Card>
            <Card.Body>
              <h2>Depoimentos de Clientes</h2>
              <p>Veja o que nossos clientes têm a dizer sobre nossa plataforma.</p>
              <Button variant="primary">Ver Depoimentos</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default HomePage;
